import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { Filter } from "src/app/interfaces/filter";
import { HTTPService } from "src/app/services/http.service";
import { UserAuthentication } from "../interfaces/user-authentication";

export interface FieldsProperties{
  internalid?:string;
  name:string;
  codecompany:string;
  codecontract:string;
  preference: FieldPropertiesPreferences;
  
}


export interface FieldPropertiesPreferences{
  nullable:boolean;
  nullableText?:string;
  defaultValue?:string;
  defaultValueText?:string;
  readonly:boolean;
  readonlyText?:string;
  required:boolean;
  requiredText?:string;
  decimal?:number;
  decimalText?:string;
  description?:string;
  descriptionText?:string;
  maxLength?:number;
  maxLengthText?:string;
  minLength?:number;
  minLengthText?:string;
  expression?:string;
  copyclean:boolean
  toolTiptext?:string;
}

@Injectable({
  providedIn: 'root',
})

export class UserConfigServices{
  
  
  savePreference(fieldProperties: FieldsProperties) {
    
    return new Promise((resolve,reject)=>{
      
      let jsonSave:Object = {
        "entityName":"Mktpcontractpref",
        "TEXT": JSON.stringify(fieldProperties.preference),
      }

      if ( fieldProperties.internalid != null ){
          jsonSave['INTERNALID'] = fieldProperties.internalid;
      }else{
          jsonSave['NAME']=fieldProperties.name.toUpperCase();
          jsonSave['TYPE']='T';
          jsonSave['CODECOMPANY']=fieldProperties.codecompany;
          jsonSave['CODECONTRACT']=fieldProperties.codecontract;
          jsonSave['CODEMKTP']='0';
          jsonSave['DESCRIPTION']='Preferencias do Campo'
      }
    
      this.sub2 = this.http.post(jsonSave,"JsonBrokerServices/save",false).subscribe(me=>{
          this.loadConfiguration(fieldProperties.codecompany,fieldProperties.name, true);
          resolve(me['INTERNALID']);
      },error=>{throw error;})
    
      
    });
  }
    
  
    sub:Subscription;
    sub1:Subscription;
    sub2:Subscription;
    public fieldProperties:FieldsProperties[] = [];

    constructor(private http:HTTPService){

    }

    ngOnDestroy(){
      if (this.sub!= null ) {this.sub.unsubscribe();}
      if (this.sub1!= null ) {this.sub1.unsubscribe();}
    }

    public loadActions(entityName:string ):Observable<Object>{

      
      let ob = new Object();
      ob= {      
        "entityName":"Mktpdicaction",
        "condition":`idinstance = ( select idinstance from Mktpdic where instancename='${entityName}')`
      };
  
      let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
      return observable;

    }

    

    public loadGetFromAction(entityName:string, uas:UserAuthentication):Observable<Object>{

      let companies = uas.companylist.map(data=>data.codecompany);
      let codecontracts = uas.companylist.map(data=>data.codecontract);

      let ob = new Object();
      ob= {      
        "entityName":"Mktpcontractpref",
        "condition":`( ( codecompany in ( ${companies.join(',')} ))  or (codecontract in (${codecontracts.join(',')}))) and codemktp=0 and (name='get${entityName}' or name = 'get${entityName}_param')`
      };
  
      let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
      return observable;

    }

    public loadGetFromActionComplex(entityName:string, uas:UserAuthentication):Observable<Object>{

      let companies = uas.companylist.map(data=>data.codecompany);
      let codecontracts = uas.companylist.map(data=>data.codecontract);

      let ob = new Object();
      ob= {      
        "entityName":"Mktpcontractpref",
        "condition":`( ( codecompany in ( ${companies.join(',')} ))  or (codecontract in (${codecontracts.join(',')}))) and codemktp=0 and (name='get${entityName}_complex' or name = 'get${entityName}_complex_param')`
      };
  
      let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
      return observable;

    }

    public loadUserConfig(userId:number, entityName:string ):Observable<Object>{

        let ob = new Object();
        ob= {      
          "entityName":"Mktpusercfg",
          "condition":`iduser = ${userId} and idinstance = ( select idinstance from Mktpdic where instancename='${entityName}')`
        };
        let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
        return observable;
    }

    public loadUserPreference(userId:number, pref:string ):Observable<Object>{

      let ob = new Object();
      ob= {      
        "entityName":"Mktpuserpref",
        "condition":`iduser = ${userId} and idpreference = '${pref}'`
      };

      let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
      return observable;
  }

  public loadUserResource(userId:number, resourceId:string ):Observable<Object>{

    let ob = new Object();
    
    ob= {      
      "entityName":"Mktpuserpref",
      "condition":`iduser = ${userId} and idpreference = '${resourceId}'`
    };

    let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
    return observable;
  }

    public saveUserResource(resourceId:string, userId:number, config:object){
      
      let jsonDec = {
          entityName:"Mktpuserpref",
          IDUSER:userId,
          IDPREFERENCE: resourceId,
          PREFERENCE: JSON.stringify(config)
      }
      return new Promise((resolve,reject) =>{

        this.sub1 = this.http.post(jsonDec,"JsonBrokerServices/save",false).subscribe({
          next:(data)=>{
              resolve(data);
          },
          error:(error)=>{
            throw error;
          }
        });
      });
    }
      
    public  saveUserCfg(jsonDec:Object,userId:number,filter:Filter[],config:object){

      return new Promise((resolve,reject) =>{

        this.sub = this.http.post(jsonDec,"JsonBrokerServices/find",false).subscribe(
          data =>{
            let idInstance:number = data["Mktpdic"][0]["IDINSTANCE"];
            let jsonSave:Object = {
              "entityName":"Mktpusercfg",
              "IDUSER": userId,
              "IDINSTANCE":idInstance,
              "CONFIG": JSON.stringify(config),
              "FILTER":JSON.stringify(filter)
            }
          
            this.sub1 = this.http.post(jsonSave,"JsonBrokerServices/save",false).subscribe(me=>{
                resolve(me);
            },error=>{
              throw error;
            });
            
          },
          error=>{
            throw error;
          
          },
          ()=> {
          }
        )

      });    
  }
  
  public loadConfigurationCompany(codecompany:string){

    return new Promise((resolve,reject)=>{
      
      let ob = null;
        
      ob = {
        "entityName":"Mktpcontractpref",
        "sql":`SELECT  A.CODECOMPANY,A.CODECONTRACT,A.INTERNALID,A.NAME,A.TEXT
              FROM MKTPCONTRACTPREF A 
              WHERE  A.CODECOMPANY IN ( ${codecompany} )
              AND A.NAME LIKE 'CONFIG_%'
              AND A.CODECOMPANY > 0 
              ORDER BY 1`
      }
       
      this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
          next:  (data)=>{
              if ( data['SQL']){
                this.fieldProperties = [];

                for ( var line of data['SQL']){
                  let preference:FieldPropertiesPreferences = JSON.parse(line['TEXT']) as FieldPropertiesPreferences;
                
                  let fp:FieldsProperties ={
                    internalid: line['INTERNALID'],
                    codecompany: line['CODECOMPANY'],
                    codecontract: line['CODECONTRACT'],
                    name: line['NAME'],
                    preference: preference
                  }
                    
                  this.fieldProperties.push(fp);
                }        
              }
      
              resolve(true);
          },
          error: (error)=>{
              localStorage.removeItem("user");
              throw error;
          }
      });
    });

  }

  public loadConfiguration(codecompany:string,name:string, refresh:boolean=false ){
    
    return new Promise((resolve,reject)=>{
      
      let index = this.fieldProperties.findIndex(d=>d.name.toUpperCase() == name.toUpperCase()  && d.codecompany==codecompany);
      // if ( !refresh ){  
      //   if (index >-1){
      //       resolve(this.fieldProperties[index]);
      //       return;
      //   }
      // }
  
      let ob = null;
        
      ob = {
        "entityName":"Mktpcontractpref",
        "sql":`SELECT  A.CODECOMPANY,A.CODECONTRACT,A.INTERNALID,A.NAME,A.TEXT
              FROM MKTPCONTRACTPREF A 
              WHERE  A.CODECOMPANY = ${codecompany}
              AND A.NAME = '${name.toUpperCase()}'
              AND A.CODECOMPANY > 0 
              ORDER BY 1`
      }
       
      this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
          next:  (data)=>{
              if ( data['SQL']){
                if ( index > -1 ){
                  this.fieldProperties.splice(index,1)
                }
                for ( var line of data['SQL']){
                  let preference:FieldPropertiesPreferences = JSON.parse(line['TEXT']) as FieldPropertiesPreferences;
                
                  let fp:FieldsProperties ={
                    internalid: line['INTERNALID'],
                    codecompany: line['CODECOMPANY'],
                    codecontract: line['CODECONTRACT'],
                    name: line['NAME'],
                    preference: preference
                  }
                    
                  this.fieldProperties.push(fp);
                }        
  
                let indexComplete = this.fieldProperties.findIndex(d=>d.name.toUpperCase() == name.toUpperCase() && d.codecompany==codecompany);          
                if (indexComplete >-1){
                    resolve(this.fieldProperties[indexComplete]);
                    return;
                }
      
              }
              resolve(null);
          },
          error: (error)=>{
              throw error;
          }
      });
    });
  }

}

